import { keyBy } from "lodash";
import * as React from "react";
import { connect } from "react-redux";
import { Alert } from "@mantine/core";
import { bindActionCreators } from "redux";
import { removeExtraOfficial } from "../../../data/actions/gameActions";
import { removeReferee, rosterGame } from "../../../data/actions/shiftActions";
import { GenericTransport } from "../../../data/api/baseApi";
import { IState } from "../../../data/reducers/state";
import {
  IAppointment,
  IAppointmentDetail,
} from "../../../types/appointments/Appointment";
import { IGame } from "../../../types/game/Game";
import { IGameConfiguration } from "../../../types/game/GameConfiguration";
import { Role } from "../../../types/persons/Role";
import { IPerson } from "../../../types/persons/person";
import { getGameKey } from "../../../util/gamehelper";
import OfficialsSelector from "./OfficialsSelector";

interface IOfficialsRosterProps {
  gameId: string;

  startDate: string;
  venue?: string

  // passthrough option for filtering
  shiftId?: string | null;
  sessionId: string;

  highlightProblemGames: boolean;
  showHideAppointmentFromSheetButton: boolean;

  // from state
  game: IGame;
  gameConfig: IGameConfiguration | null;
  gameAppointmentsWithPosition: { _id: string; position: string }[];


  personMap: { [personId: string]: IPerson };
  appointmentMap: { [appointmentId: string]: IAppointment<IAppointmentDetail> };

  actions: {
    rosterGame: (
      gameId: string,
      person: string,
      position: string,
      hasApprentice: boolean,
      shiftSessionId: string,
      startDate?: string,
      venue?: string,
    ) => Promise<GenericTransport<null>>;
    removeReferee: (
      gameId: string,
      position: string,
      shiftSessionId: string,
      comment: string,
    ) => Promise<GenericTransport<null>>;
    removeExtraOfficial: (
      gameId: string,
      position: string,
      shiftSessionId: string,
    ) => Promise<IGame>;
  };
}

class OfficialsRoster extends React.PureComponent<IOfficialsRosterProps, null> {
  constructor(props) {
    super(props);

    this.rosterReferee = this.rosterReferee.bind(this);
    this.removeReferee = this.removeReferee.bind(this);
  }

  rosterReferee(position: string, person: string, hasApprentice: boolean) {
    return this.props.actions
      .rosterGame(
        this.props.gameId,
        person,
        position,
        hasApprentice,
        this.props.sessionId,
        this.props.startDate,
        this.props.venue,
      )
      .then((data) => {
        // const personObj: IPerson = this.props.personMap[person]
        // if (isReferee && personObj?.referee?.grade == BasketballGrade.apprentice1 || personObj?.referee?.grade == BasketballGrade.apprentice2) {
        //   // have to ask what referree to add the loading too
        //   const configByPosition = keyBy(this.props.gameConfig?.fields, f => f.identifier)
        //   const personToAllocateBonusTo = this.props.gameAppointmentsWithPosition
        //     .filter(f => configByPosition[f.position].role == Role.referee)
        //     .map(f => (this.props.appointmentMap[f._id].person)
        //     .map(ap => a.person)
        // }
      });
  }

  removeReferee(position, comment?: string) {
    return this.props.actions.removeReferee(
      this.props.gameId,
      position,
      this.props.sessionId,
      comment,
    );
  }

  render() {
    const { gameId, gameConfig, shiftId, game } = this.props;

    if (!gameConfig) return <p>No game config loaded</p>;

    const refereePositions = gameConfig.fields.filter((r) =>
      Role.hasRole(r.role, Role.referee),
    );
    const scoretablePositions = gameConfig.fields.filter((r) =>
      Role.hasRole(r.role, Role.scoretable),
    );
    const statisticianPositions = gameConfig.fields.filter((r) =>
      Role.hasRole(r.role, Role.statistician),
    );
    const unsupportedPositions = gameConfig.fields.filter(
      (r) =>
        !(
          Role.hasRole(r.role, Role.scoretable) ||
          Role.hasRole(r.role, Role.referee) ||
          Role.hasRole(r.role, Role.statistician)
        ),
    );
    const officials = keyBy(
      this.props.gameAppointmentsWithPosition,
      "position",
    );

    const style: React.CSSProperties = {};
    const isMissingReferees = refereePositions.some((r) => {
      const ref = officials[r.identifier];
      return !ref;
    });
    if (this.props.highlightProblemGames && isMissingReferees) {
      style.backgroundColor = "var(--color-attention-red)";
    }

    return (
      <div style={style}>
        {refereePositions.map((r) => {
          const ref = officials[r.identifier];
          return (
            <OfficialsSelector
              key={r.identifier}
              name={r.identifier}
              role={r.role}
              label={r.friendlyName}
              gameId={gameId}
              shiftId={shiftId}
              sessionId={this.props.sessionId}
              onChange={this.rosterReferee}
              onClear={this.removeReferee}
              appointmentId={ref && ref._id}
              startDate={this.props.startDate}
              venue={this.props.venue}
              showHideAppointmentFromSheetButton={this.props.showHideAppointmentFromSheetButton}
            // hasApprentice={ref && !!ref.apprentice}
            />
          );
        })}

        {scoretablePositions && scoretablePositions.length > 0 && (
          <>
            <hr />
            <b>Scorers</b>{" "}
            {scoretablePositions.map((r) => {
              const ref = officials[r.identifier];
              return (
                <OfficialsSelector
                  key={r.identifier}
                  name={r.identifier}
                  label={r.friendlyName}
                  role={r.role}
                  gameId={gameId}
                  shiftId={shiftId}
                  sessionId={this.props.sessionId}
                  onChange={this.rosterReferee}
                  onClear={this.removeReferee}
                  appointmentId={ref && ref._id}
                  showHideAppointmentFromSheetButton={this.props.showHideAppointmentFromSheetButton}
                />
              );
            })}
          </>
        )}

        {statisticianPositions && statisticianPositions.length > 0 && (
          <>
            <hr />
            <b>Statisticians</b>{" "}
            {statisticianPositions.map((r) => {
              const official = officials[r.identifier];
              return (
                <OfficialsSelector
                  key={r.identifier}
                  name={r.identifier}
                  label={r.friendlyName}
                  role={r.role}
                  gameId={gameId}
                  shiftId={shiftId}
                  sessionId={this.props.sessionId}
                  onChange={this.rosterReferee}
                  onClear={this.removeReferee}
                  appointmentId={official && official._id}
                  showHideAppointmentFromSheetButton={this.props.showHideAppointmentFromSheetButton}
                />
              );
            })}
          </>
        )}

        {unsupportedPositions.length > 0 && (
          <Alert color="red">
            The following positions are currently unsupported:{" "}
            {unsupportedPositions.map((r) => r.identifier).join(", ")}
          </Alert>
        )}

        {game?.referees?.extraFields &&
          game?.referees?.extraFields.length > 0 && (
            <>
              <hr />
              <b>Extra officials</b>{" "}
              {game?.referees?.extraFields.map((r) => {
                const ref = officials[r.identifier];
                return (
                  <OfficialsSelector
                    key={r.identifier}
                    name={r.identifier}
                    label={r.friendlyName}
                    role={r.role}
                    gameId={gameId}
                    shiftId={shiftId}
                    sessionId={this.props.sessionId}
                    onChange={this.rosterReferee}
                    onClear={this.removeReferee}
                    appointmentId={ref && ref._id}
                    showHideAppointmentFromSheetButton={this.props.showHideAppointmentFromSheetButton}
                    additionalActions={[
                      {
                        title: "Remove extra official",
                        action: () =>
                          this.props.actions.removeExtraOfficial(
                            gameId,
                            r.identifier,
                            this.props.sessionId,
                          ),
                      },
                    ]}
                  />
                );
              })}
            </>
          )}
      </div>
    );
  }
}

function mapStateToProps(state: IState, props): Partial<IOfficialsRosterProps> {
  const config = props.officials && props.officials.config;
  const game = state.games[props.gameId];
  let gameAppointmentsWithPosition: { _id: string; position: string }[] = [];
  if (game) {
    gameAppointmentsWithPosition =
      state.appointments.byVenueDateCourt[
      getGameKey(game.date, game.venue, game.court)
      ] || [];
  }
  return {
    gameConfig: state.gameConfigurations.map[config || "twoPO"],
    game,
    gameAppointmentsWithPosition,
    personMap: state.persons.map,
    appointmentMap: state.appointments.map,
  };
}

function mapDispatchToProps(dispatch): Partial<IOfficialsRosterProps> {
  return {
    // @ts-ignore
    actions: bindActionCreators(
      { rosterGame, removeReferee, removeExtraOfficial },
      dispatch,
    ),
  };
}

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(OfficialsRoster);
